/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientToJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientToJSONTyped,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient';
import type { CreateSourceTagRequest } from './CreateSourceTagRequest';
import {
    CreateSourceTagRequestFromJSON,
    CreateSourceTagRequestFromJSONTyped,
    CreateSourceTagRequestToJSON,
    CreateSourceTagRequestToJSONTyped,
} from './CreateSourceTagRequest';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistToJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistToJSONTyped,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist';
import type { AdmissionStatus } from './AdmissionStatus';
import {
    AdmissionStatusFromJSON,
    AdmissionStatusFromJSONTyped,
    AdmissionStatusToJSON,
    AdmissionStatusToJSONTyped,
} from './AdmissionStatus';
import type { CreateLeadInfoRequest } from './CreateLeadInfoRequest';
import {
    CreateLeadInfoRequestFromJSON,
    CreateLeadInfoRequestFromJSONTyped,
    CreateLeadInfoRequestToJSON,
    CreateLeadInfoRequestToJSONTyped,
} from './CreateLeadInfoRequest';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatus } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatus';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatusFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatusFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatusToJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatusToJSONTyped,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatus';
import type { AdmissionStatusCode } from './AdmissionStatusCode';
import {
    AdmissionStatusCodeFromJSON,
    AdmissionStatusCodeFromJSONTyped,
    AdmissionStatusCodeToJSON,
    AdmissionStatusCodeToJSONTyped,
} from './AdmissionStatusCode';
import type { LeadAdmissionStatusInfo } from './LeadAdmissionStatusInfo';
import {
    LeadAdmissionStatusInfoFromJSON,
    LeadAdmissionStatusInfoFromJSONTyped,
    LeadAdmissionStatusInfoToJSON,
    LeadAdmissionStatusInfoToJSONTyped,
} from './LeadAdmissionStatusInfo';

/**
 * 
 * @export
 * @interface FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead
 */
export interface FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    facility_id?: string;
    /**
     * 
     */
    original_facility_id?: string | null;
    /**
     * 
     */
    lead_received_date?: string;
    /**
     * 
     */
    first_name?: string;
    /**
     * 
     */
    last_name?: string;
    /**
     * 
     */
    source_name?: string;
    /**
     * 
     */
    status_id?: string;
    /**
     * 
     */
    failed_review_stage_status_id?: string | null;
    /**
     * 
     */
    bd_action_failed?: boolean | null;
    /**
     * 
     */
    auto_accepted_by_ai?: boolean;
    /**
     * 
     */
    internal_response_reason?: string;
    /**
     * 
     */
    external_response_reason?: string;
    /**
     * 
     */
    connector?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadConnectorEnum;
    /**
     * 
     */
    status?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatus;
    /**
     * 
     */
    waitlist?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlist;
    /**
     * Legacy display name. Use `admission_status_code`.
     * @deprecated
     */
    admission_status?: AdmissionStatus;
    /**
     * 
     */
    admission_status_code?: AdmissionStatusCode;
    /**
     * 
     */
    screener_lead_info?: CreateLeadInfoRequest;
    /**
     * 
     */
    facility?: CreateSourceTagRequest;
    /**
     * 
     */
    external_ehr_patient?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatient;
    /**
     * 
     */
    admission_status_info?: LeadAdmissionStatusInfo;
}


/**
 * @export
 */
export const FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadConnectorEnum = {
    Aida: 'Aida',
    Aidin: 'Aidin',
    Ensocare: 'Ensocare',
    EnsocareVa: 'Ensocare VA',
    EpicCareLink: 'EpicCare Link',
    EpicCareLinkAlbanyMed: 'EpicCare Link Albany Med',
    EpicCareLinkAllinaHealth: 'EpicCare Link Allina Health',
    EpicCareLinkAsante: 'EpicCare Link Asante',
    EpicCareLinkAscension: 'EpicCare Link Ascension',
    EpicCareLinkAscensionWi: 'EpicCare Link Ascension WI',
    EpicCareLinkAspirusHealth: 'EpicCare Link Aspirus Health',
    EpicCareLinkAtriumHealth: 'EpicCare Link Atrium Health',
    EpicCareLinkBaptistHealth: 'EpicCare Link Baptist Health',
    EpicCareLinkBaptistOneCare: 'EpicCare Link Baptist One Care',
    EpicCareLinkBenefisHealthSystem: 'EpicCare Link Benefis Health System',
    EpicCareLinkBaylorScottWhiteHealth: 'EpicCare Link Baylor Scott & White Health',
    EpicCareLinkBonSecoursMercyHealth: 'EpicCare Link Bon Secours Mercy Health',
    EpicCareLinkBostonMedicalCenter: 'EpicCare Link Boston Medical Center',
    EpicCareLinkBronsonHealthcare: 'EpicCare Link Bronson Healthcare',
    EpicCareLinkBryanHealth: 'EpicCare Link Bryan Health',
    EpicCareLinkBsaHospital: 'EpicCare Link BSA Hospital',
    EpicCareLinkCapeCodHealthcare: 'EpicCare Link Cape Cod Healthcare',
    EpicCareLinkCaroMont: 'EpicCare Link CaroMont',
    EpicCareLinkCarolinaEast: 'EpicCare Link Carolina East',
    EpicCareLinkErlanger: 'EpicCare Link Erlanger',
    EpicCareLinkCentraCare: 'EpicCare Link CentraCare',
    EpicCareLinkChristusHealth: 'EpicCare Link CHRISTUS Health',
    EpicCareLinkConeHealth: 'EpicCare Link Cone Health',
    EpicCareLinkCovenantHealthCare: 'EpicCare Link Covenant HealthCare',
    EpicCareLinkDeaconess: 'EpicCare Link Deaconess',
    EpicCareLinkDenverHealth: 'EpicCare Link Denver Health',
    EpicCareLinkDukeHealth: 'EpicCare Link Duke Health',
    EpicCareLinkEcuHealth: 'EpicCare Link ECU Health',
    EpicCareLinkElCaminoHealth: 'EpicCare Link El Camino Health',
    EpicCareLinkEnloeHealth: 'EpicCare Link Enloe Health',
    EpicCareLinkFirstHealth: 'EpicCare Link FirstHealth',
    EpicCareLinkFmolhsCareConnect: 'EpicCare Link FMOLHS CareConnect',
    EpicCareLinkSelectMedical: 'EpicCare Link Select Medical',
    EpicCareLinkParkview: 'EpicCare Link Parkview',
    EpicCareLinkGenesisHealthcareSystem: 'EpicCare Link Genesis Healthcare System',
    EpicCareLinkGuthrie: 'EpicCare Link Guthrie',
    EpicCareLinkHartfordHealthCare: 'EpicCare Link Hartford HealthCare',
    EpicCareLinkHackensackMeridianHealth: 'EpicCare Link Hackensack Meridian Health',
    EpicCareLinkHealthPartners: 'EpicCare Link HealthPartners',
    EpicCareLinkHealtheConnection: 'EpicCare Link HealtheConnection',
    EpicCareLinkHennepinCountyMedicalCenter: 'EpicCare Link Hennepin County Medical Center',
    EpicCareLinkHillcrestHealthCareSystem: 'EpicCare Link Hillcrest HealthCare System',
    EpicCareLinkHospitalSistersHealthSystem: 'EpicCare Link Hospital Sisters Health System',
    EpicCareLinkHurleyMedicalCenter: 'EpicCare Link Hurley Medical Center',
    EpicCareLinkIowaHealthCare: 'EpicCare Link Iowa Health Care',
    EpicCareLinkIntegrisHealth: 'EpicCare Link Integris Health',
    EpicCareLinkJupiterMedicalCenter: 'EpicCare Link Jupiter Medical Center',
    EpicCareLinkKaiserPermanente: 'EpicCare Link Kaiser Permanente',
    EpicCareLinkKingsDaughtersHealthSystem: 'EpicCare Link King\'s Daughters Health System',
    EpicCareLinkLegacyHealthyPlanet: 'EpicCare Link Legacy Healthy Planet',
    EpicCareLinkMHealthFairview: 'EpicCare Link M Health Fairview',
    EpicCareLinkMainLineHealth: 'EpicCare Link Main Line Health',
    EpicCareLinkMayoClinic: 'EpicCare Link Mayo Clinic',
    EpicCareLinkMercy: 'EpicCare Link Mercy',
    EpicCareLinkMethodistHospitals: 'EpicCare Link Methodist Hospitals',
    EpicCareLinkMethodistHealthSystem: 'EpicCare Link Methodist Health System',
    EpicCareLinkMiddlesexHealth: 'EpicCare Link Middlesex Health',
    EpicCareLinkMyMichiganHealth: 'EpicCare Link MyMichigan Health',
    EpicCareLinkNch: 'EpicCare Link NCH',
    EpicCareLinkNortonHealthcare: 'EpicCare Link Norton Healthcare',
    EpicCareLinkNorthMemorialHealth: 'EpicCare Link North Memorial Health',
    EpicCareLinkOchsnerHealthNetwork: 'EpicCare Link Ochsner Health Network',
    EpicCareLinkOhioHealth: 'EpicCare Link OhioHealth',
    EpicCareLinkOklahomaHeartHospital: 'EpicCare Link Oklahoma Heart Hospital',
    EpicCareLinkOsfHealthCare: 'EpicCare Link OSF HealthCare',
    EpicCareLinkOwensboroHealth: 'EpicCare Link Owensboro Health',
    EpicCareLinkPiedmont: 'EpicCare Link Piedmont',
    EpicCareLinkProvidence: 'EpicCare Link Providence',
    EpicCareLinkProvidenceWashington: 'EpicCare Link Providence Washington',
    EpicCareLinkSaintFrancis: 'EpicCare Link Saint Francis',
    EpicCareLinkSalemHealth: 'EpicCare Link Salem Health',
    EpicCareLinkShannonHealth: 'EpicCare Link Shannon Health',
    EpicCareLinkStElizabethHealthcare: 'EpicCare Link St. Elizabeth Healthcare',
    EpicCareLinkStormontVailHealth: 'EpicCare Link Stormont Vail Health',
    EpicCareLinkSsmHealth: 'EpicCare Link SSM Health',
    EpicCareLinkTexasHealth: 'EpicCare Link Texas Health',
    EpicCareLinkTheQueensHealthSystem: 'EpicCare Link The Queen\'s Health System',
    EpicCareLinkThedaCare: 'EpicCare Link ThedaCare',
    EpicCareLinkTriHealth: 'EpicCare Link TriHealth',
    EpicCareLinkTrinityHealth: 'EpicCare Link Trinity Health',
    EpicCareLinkUcHealth: 'EpicCare Link UCHealth',
    EpicCareLinkUncHealth: 'EpicCare Link UNC Health',
    EpicCareLinkUConnHealth: 'EpicCare Link UConn Health',
    EpicCareLinkUnityPointHealth: 'EpicCare Link UnityPoint Health',
    EpicCareLinkUniversityOfCincinnati: 'EpicCare Link University of Cincinnati',
    EpicCareLinkUniversityOfKansas: 'EpicCare Link University of Kansas',
    EpicCareLinkUniversityOfKansasStFrancis: 'EpicCare Link University of Kansas St Francis',
    EpicCareLinkUniversityOfMarylandMedicalSystem: 'EpicCare Link University of Maryland Medical System',
    EpicCareLinkUniversityOfMississippiMedicalCenter: 'EpicCare Link University of Mississippi Medical Center',
    EpicCareLinkUniversityOfRochesterMedicine: 'EpicCare Link University of Rochester Medicine',
    EpicCareLinkUniversityHealth: 'EpicCare Link University Health',
    EpicCareLinkUniversityOfUtah: 'EpicCare Link University of Utah',
    EpicCareLinkUpmcPinnacle: 'EpicCare Link UPMC Pinnacle',
    EpicCareLinkSouthShoreHealth: 'EpicCare Link South Shore Health',
    EpicCareLinkSouthcoast: 'EpicCare Link Southcoast',
    EpicCareLinkStLukes: 'EpicCare Link St. Luke\'s',
    EpicCareLinkPremierHealth: 'EpicCare Link Premier Health',
    EpicCareLinkUtHealthEastTexas: 'EpicCare Link UT Health East Texas',
    EpicCareLinkUtSouthwesternMedicalCenter: 'EpicCare Link UT Southwestern Medical Center',
    EpicCareLinkVitruvianHealth: 'EpicCare Link Vitruvian Health',
    EpicCareLinkWellstar: 'EpicCare Link Wellstar',
    EpicCareLinkKetteringHealth: 'EpicCare Link Kettering Health',
    EpicCareLinkOlmstedMedicalCenter: 'EpicCare Link Olmsted Medical Center',
    EpicCareLinkFranciscanHealth: 'EpicCare Link Franciscan Health',
    EpicCareLinkMohawkValleyHealthSystem: 'EpicCare Link Mohawk Valley Health System',
    EpicCareLinkGeisinger: 'EpicCare Link Geisinger',
    EpicCareLinkJpsHealthNetwork: 'EpicCare Link JPS Health Network',
    EpicCareLinkPortneuf: 'EpicCare Link Portneuf',
    EpicCareLinkCheyenneRegionalMedicalCenter: 'EpicCare Link Cheyenne Regional Medical Center',
    EpicCareLinkUniversityMedicalCenter: 'EpicCare Link University Medical Center',
    EpicCareLinkCapeFearValley: 'EpicCare Link Cape Fear Valley',
    EpicCareLinkLexingtonMedicalCenter: 'EpicCare Link Lexington Medical Center',
    EpicCareLinkMedicalUniversityOfSouthCarolina: 'EpicCare Link Medical University of South Carolina',
    EpicCareLinkEssentiaHealth: 'EpicCare Link Essentia Health',
    EpicCareLinkUwHealth: 'EpicCare Link UW Health',
    EpicCareLinkNorthMississippiHealthServices: 'EpicCare Link North Mississippi Health Services',
    EpicCareLinkOregonHealthScienceUniversity: 'EpicCare Link Oregon Health & Science University',
    EpicCareLinkLcmcHealth: 'EpicCare Link LCMC Health',
    EpicCareLinkRwjBarnabas: 'EpicCare Link RWJ Barnabas',
    EpicCareLinkLovelaceHealthSystem: 'EpicCare Link Lovelace Health System',
    EpicCareLinkRochesterRegionalHealth: 'EpicCare Link Rochester Regional Health',
    EpicCareLinkAtlanticHealth: 'EpicCare Link Atlantic Health',
    EpicCareLinkBalladHealth: 'EpicCare Link Ballad Health',
    EpicCareLinkGreatRiver: 'EpicCare Link Great River',
    EpicCareLinkMountainsideMedicalCenter: 'EpicCare Link Mountainside Medical Center',
    EpicCareLinkUkHealthCare: 'EpicCare Link UK HealthCare',
    EpicCareLinkCghMedicalCenter: 'EpicCare Link CGH Medical Center',
    EpicCareLinkMosaicLifeCare: 'EpicCare Link Mosaic Life Care',
    EpicCareLinkGundersenHealth: 'EpicCare Link Gundersen Health',
    EpicCareLinkCoxHealth: 'EpicCare Link CoxHealth',
    EpicCareLinkSingingRiver: 'EpicCare Link Singing River',
    EpicCareLinkLickingMemorialHealth: 'EpicCare Link Licking Memorial Health',
    EpicCareLinkWakeMed: 'EpicCare Link WakeMed',
    Fax: 'Fax',
    ManualUpload: 'Manual Upload',
    ManualCopy: 'Manual Copy',
    Repisodic: 'Repisodic',
    WellSkyIntake: 'WellSky Intake',
    WellSkyIntakeCarePortQuickCase: 'WellSky Intake CarePort QuickCase',
    WellSkyCarePortReferralIntake: 'WellSky CarePort Referral Intake',
    WellSkyReferralManagement: 'WellSky Referral Management',
    WellSkyReferralManagementWebReferral: 'WellSky Referral Management Web Referral',
    FourNext: 'Four Next',
    Roc: 'Roc',
} as const;
export type FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadConnectorEnum = typeof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadConnectorEnum[keyof typeof FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadConnectorEnum];


/**
 * Check if a given object implements the FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead interface.
 */
export function instanceOfFindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead(value: object): value is FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead {
    return true;
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSON(json: any): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead {
    return FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSONTyped(json, false);
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'facility_id': json['facility_id'] == null ? undefined : json['facility_id'],
        'original_facility_id': json['original_facility_id'] === undefined ? undefined : json['original_facility_id'] === null ? null : json['original_facility_id'],
        'lead_received_date': json['lead_received_date'] == null ? undefined : json['lead_received_date'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'source_name': json['source_name'] == null ? undefined : json['source_name'],
        'status_id': json['status_id'] == null ? undefined : json['status_id'],
        'failed_review_stage_status_id': json['failed_review_stage_status_id'] === undefined ? undefined : json['failed_review_stage_status_id'] === null ? null : json['failed_review_stage_status_id'],
        'bd_action_failed': json['bd_action_failed'] === undefined ? undefined : json['bd_action_failed'] === null ? null : json['bd_action_failed'],
        'auto_accepted_by_ai': json['auto_accepted_by_ai'] == null ? undefined : json['auto_accepted_by_ai'],
        'internal_response_reason': json['internal_response_reason'] == null ? undefined : json['internal_response_reason'],
        'external_response_reason': json['external_response_reason'] == null ? undefined : json['external_response_reason'],
        'connector': json['connector'] == null ? undefined : json['connector'],
        'status': json['status'] == null ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatusFromJSON(json['status']),
        'waitlist': json['waitlist'] == null ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistFromJSON(json['waitlist']),
        'admission_status': json['admission_status'] == null ? undefined : AdmissionStatusFromJSON(json['admission_status']),
        'admission_status_code': json['admission_status_code'] == null ? undefined : AdmissionStatusCodeFromJSON(json['admission_status_code']),
        'screener_lead_info': json['screener_lead_info'] == null ? undefined : CreateLeadInfoRequestFromJSON(json['screener_lead_info']),
        'facility': json['facility'] == null ? undefined : CreateSourceTagRequestFromJSON(json['facility']),
        'external_ehr_patient': json['external_ehr_patient'] == null ? undefined : FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientFromJSON(json['external_ehr_patient']),
        'admission_status_info': json['admission_status_info'] == null ? undefined : LeadAdmissionStatusInfoFromJSON(json['admission_status_info']),
    };
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadToJSON(json: any): FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead {
    return FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadToJSONTyped(json, false);
}

export function FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadToJSONTyped(value?: FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'facility_id': value['facility_id'],
        'original_facility_id': value['original_facility_id'],
        'lead_received_date': value['lead_received_date'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'source_name': value['source_name'],
        'status_id': value['status_id'],
        'failed_review_stage_status_id': value['failed_review_stage_status_id'],
        'bd_action_failed': value['bd_action_failed'],
        'auto_accepted_by_ai': value['auto_accepted_by_ai'],
        'internal_response_reason': value['internal_response_reason'],
        'external_response_reason': value['external_response_reason'],
        'connector': value['connector'],
        'status': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadStatusToJSON(value['status']),
        'waitlist': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadWaitlistToJSON(value['waitlist']),
        'admission_status': AdmissionStatusToJSON(value['admission_status']),
        'admission_status_code': AdmissionStatusCodeToJSON(value['admission_status_code']),
        'screener_lead_info': CreateLeadInfoRequestToJSON(value['screener_lead_info']),
        'facility': CreateSourceTagRequestToJSON(value['facility']),
        'external_ehr_patient': FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadExternalEhrPatientToJSON(value['external_ehr_patient']),
        'admission_status_info': LeadAdmissionStatusInfoToJSON(value['admission_status_info']),
    };
}

